import { images } from "../../../../assets";
import { LeftInfoModalProps } from "../../../../components/left-info-modal/left-info-modal-layout";

export const MODAL_SEND_EMAIL_ERROR: Partial<LeftInfoModalProps> = {
  className: "error",
  active: true,
  img: images.WarningError,
  mainTitle: "Error",
  buttonText: "Continuar",
  noSecondaryButton: true,
};

export const MODAL_SEND_EMAIL_OK: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconCheckGreen2,
  mainTitle: "Aviso",
  mainText: "Los datos han sido enviados correctamente",
  buttonText: "Continuar",
  noSecondaryButton: true,
};

export const MODAL_ASK_CONFIRMATION: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconCheckGreen2,
  mainTitle: "Aviso",
  secondaryText: "¿Desea continuar?",
  buttonText: "Si",
  closeButtonText: "No",
};

export const MODAL_CHANGE_DATA_INFO: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconCheckGreen2,
  mainTitle: "Aviso",
  mainText: "Se van a cambiar los datos del cliente en todas sus pólizas de la compañía.",
  secondaryText: "¿Desea continuar con la modificación?",
  buttonText: "Si",
  closeButtonText: "No",
  noSecondaryButton: true,
};

export const MODAL_SUBMIT_DOCS_ERROR: Partial<LeftInfoModalProps> = {
  className: "error",
  active: true,
  img: images.WarningError,
  mainTitle: "Error",
  mainText: "Se ha producido un error al subir los documentos.",
  secondaryText: "Inténtelo más tarde",
  buttonText: "Cerrar",
  noSecondaryButton: true,
};

export const MODAL_CHANGED_OK: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconCheckGreen2,
  mainTitle: "Aviso",
  mainText:
    "Los cambios han sido registrados satisfactoriamente, al día siguiente podrán ser consultados",
  buttonText: "Continuar",
  noSecondaryButton: true,
};

export const MODAL_CHANGE_DEFERRED: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconCheckGreen2,
  mainTitle: "Aviso",
  mainText: "Los cambios se realizarán de forma diferida",
  buttonText: "Continuar",
  noSecondaryButton: true,
};

export const MODAL_CHIP_ERROR: Partial<LeftInfoModalProps> = {
  className: "info",
  active: true,
  img: images.IconWarningYellow,
  mainTitle: "Aviso",
  mainText:
    "El número de microchip no puede estar duplicado, ya está siendo utilizado por otra mascota en la base de datos",
  buttonText: "Aceptar",
  noSecondaryButton: true,
};
